import { Edit, SimpleForm } from "react-admin";

import { EditToolbar } from "../../common/EditToolbar";
import { GenreSimpleFormContent } from "./components/GenreSimpleFormContent";
import { EditHeader } from "../../utils/header";

export function GenreEdit(): JSX.Element {
    return (
        <Edit mutationMode="pessimistic" title={<EditHeader field="name" />}>
            <SimpleForm toolbar={<EditToolbar />}>
                <GenreSimpleFormContent />
            </SimpleForm>
        </Edit>
    );
}
